import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const mobileSettings: ApiFunc<`${typeof API.MOBILE_SETTINGS}`, 'post'> = data =>
  instance.post(API.MOBILE_SETTINGS, data)

export const mobileSettingsVersions: ApiFunc<`${typeof API.MOBILE_SETTINGS_VERSIONS}`, 'get'> = data =>
  instance.get(API.MOBILE_SETTINGS_VERSIONS, {
    params: data,
  })
